import { ApplicationReviewScreen } from "@/features/staff/applications";

export default ApplicationReviewScreen;
